import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONTROL } from '../../../../components';
import styles from "../../../styles.module.css";
import { generateBaseItems, getEip } from '../../../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var loadBalancerTypeItem = {
  Shared: 'Shared',
  Dedicated: 'Dedicated'
};
var balancerWorkLevelItem = {
  HTTP: 'HTTP/HTTPS L7',
  TCP: 'TCP/UDP L4'
};
var getElbConfigControls = function getElbConfigControls() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'elb';
  var accessorKey = {
    loadBalancerType: "".concat(prefix, ".type"),
    accessibilityZoneQuantity: "".concat(prefix, ".accessibilityZoneQuantity"),
    balancerWorkLevel: "".concat(prefix, ".balancerWorkLevel"),
    lcu: "".concat(prefix, ".lcu")
  };
  return {
    loadBalancerType: {
      type: CONTROL.Segmented,
      accessorKey: accessorKey.loadBalancerType,
      defaultValue: loadBalancerTypeItem.Shared,
      items: [{
        value: loadBalancerTypeItem.Shared,
        label: 'Общий (бесплатный)'
      }, {
        value: loadBalancerTypeItem.Dedicated,
        label: 'Выделенный'
      }],
      decoratorProps: {
        label: 'Тип балансировщика нагрузки',
        labelTooltip: /*#__PURE__*/_jsxs("ul", {
          className: styles.tip,
          children: [/*#__PURE__*/_jsx("li", {
            children: "\u041E\u0431\u0449\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0449\u0438\u043A \u043D\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E, \u0440\u0435\u0441\u0443\u0440\u0441\u044B \u0440\u0430\u0437\u0432\u0435\u0440\u0442\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0432 \u043A\u043B\u0430\u0441\u0442\u0435\u0440\u043D\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435 \u0438 \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u044E\u0442\u0441\u044F \u043C\u0435\u0436\u0434\u0443 \u0431\u0430\u043B\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0449\u0438\u043A\u0430\u043C\u0438 \u043D\u0430\u0433\u0440\u0443\u0437\u043A\u0438"
          }), /*#__PURE__*/_jsx("li", {
            children: "\u0412\u044B\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0439 \u0431\u0430\u043B\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0449\u0438\u043A \u043D\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u0434\u0432\u043E\u0439\u043D\u043E\u0439 \u0441\u0442\u0435\u043A IPv4/IPv6 \u0438 \u0440\u0430\u0437\u0432\u0435\u0440\u0442\u044B\u0432\u0430\u043D\u0438\u0435 \u0432 \u0440\u0430\u0437\u043D\u044B\u0445 \u0437\u043E\u043D\u0430\u0445 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442\u0438, \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u043F\u0435\u0446\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0439 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u044E\u0442 \u0433\u0438\u0431\u043A\u0443\u044E \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0443"
          })]
        })
      }
    },
    accessibilityZoneQuantity: {
      type: CONTROL.Segmented,
      accessorKey: accessorKey.accessibilityZoneQuantity,
      defaultValue: '1',
      items: generateBaseItems([1, 2, 3, 4]),
      watchedControls: {
        loadBalancerType: accessorKey.loadBalancerType
      },
      relateFn: function relateFn(_ref) {
        var loadBalancerType = _ref.loadBalancerType;
        if (loadBalancerType === loadBalancerTypeItem.Shared) {
          return {
            uiProps: {
              visible: false
            }
          };
        }
      },
      decoratorProps: {
        label: 'Количество зон доступности развертывания'
      }
    },
    dedicatedObj: {
      type: CONTROL.Object,
      ui: [['balancerWorkLevel', 'lcu']],
      visible: true,
      watchedControls: {
        loadBalancerType: accessorKey.loadBalancerType
      },
      relateFn: function relateFn(_ref2) {
        var loadBalancerType = _ref2.loadBalancerType;
        if (loadBalancerType === loadBalancerTypeItem.Shared) {
          return {
            visible: false
          };
        }
      },
      controls: {
        balancerWorkLevel: {
          type: CONTROL.SelectSingle,
          accessorKey: accessorKey.balancerWorkLevel,
          defaultValue: balancerWorkLevelItem.HTTP,
          items: [{
            value: balancerWorkLevelItem.HTTP,
            label: 'Балансировка нагрузки приложений (HTTP/HTTPS)'
          }, {
            value: balancerWorkLevelItem.TCP,
            label: 'Балансировка сетевой нагрузки (TCP/UDP)'
          }],
          decoratorProps: {
            label: 'Уровень работы',
            labelTooltip: /*#__PURE__*/_jsxs("ul", {
              className: styles.tip,
              children: [/*#__PURE__*/_jsx("li", {
                children: "\u0417\u0430\u043F\u0440\u043E\u0441\u044B \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043D\u0430 \u0440\u0430\u0437\u043D\u044B\u0435 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0435 \u0441\u0435\u0440\u0432\u0435\u0440\u044B \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0430. \u0411\u0430\u043B\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u043A\u0430 \u043D\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u043E \u043F\u043E\u0434\u0445\u043E\u0434\u0438\u0442 \u0434\u043B\u044F \u0441\u0446\u0435\u043D\u0430\u0440\u0438\u0435\u0432, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u0442\u0440\u0430\u0444\u0438\u043A\u043E\u043C HTTP/HTTPS, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u0434\u043B\u044F \u0432\u0435\u0431-\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439."
              }), /*#__PURE__*/_jsx("li", {
                children: "\u0411\u0430\u0437\u043E\u0432\u0430\u044F \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0438\u0437\u0430\u0446\u0438\u044F \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F \u0434\u043B\u044F \u0442\u0440\u0430\u0444\u0438\u043A\u0430 TCP/UDP \u043D\u0430 \u0443\u0440\u043E\u0432\u043D\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0438. \u0411\u0430\u043B\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u043A\u0430 \u0441\u0435\u0442\u0435\u0432\u043E\u0439 \u043D\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u043E \u043F\u043E\u0434\u0445\u043E\u0434\u0438\u0442 \u0434\u043B\u044F \u0442\u0430\u043A\u0438\u0445 \u0441\u0446\u0435\u043D\u0430\u0440\u0438\u0435\u0432, \u043A\u0430\u043A \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0430 \u0444\u0430\u0439\u043B\u043E\u0432, \u043E\u0431\u043C\u0435\u043D \u043C\u0433\u043D\u043E\u0432\u0435\u043D\u043D\u044B\u043C\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u043F\u043E\u0442\u043E\u043A\u043E\u0432\u043E\u0435 \u0432\u0438\u0434\u0435\u043E."
              })]
            })
          }
        },
        lcu: {
          type: CONTROL.Segmented,
          accessorKey: accessorKey.lcu,
          defaultValue: '10',
          items: generateBaseItems([10, 20, 40, 80, 200, 400]),
          watchedControls: {
            balancerWorkLevel: accessorKey.balancerWorkLevel
          },
          relateFn: function relateFn(_ref3) {
            var balancerWorkLevel = _ref3.balancerWorkLevel;
            if (balancerWorkLevel === balancerWorkLevelItem.HTTP) {
              return {
                items: generateBaseItems([10, 20, 40, 200, 400])
              };
            }
          },
          decoratorProps: {
            label: 'LCU',
            labelTooltip: 'Единица ресурса балансировщика нагрузки'
          }
        }
      }
    }
  };
};
var elbTypeControls = getElbConfigControls('configs[0]');
var getArrConfigControl = function getArrConfigControl(multiple) {
  var _getElbConfigControls = getElbConfigControls(),
    loadBalancerType = _getElbConfigControls.loadBalancerType,
    accessibilityZoneQuantity = _getElbConfigControls.accessibilityZoneQuantity,
    dedicatedObj = _getElbConfigControls.dedicatedObj;
  return {
    type: CONTROL.Object,
    ui: [['loadBalancerType', 'accessibilityZoneQuantity'], 'dedicatedObj'],
    decoratorProps: multiple ? {
      label: 'Конфигурация'
    } : undefined,
    controls: {
      loadBalancerType: _objectSpread(_objectSpread({}, loadBalancerType), {}, {
        defaultValue: loadBalancerTypeItem.Dedicated,
        items: [{
          value: loadBalancerTypeItem.Shared,
          label: 'Общий (бесплатный)',
          disabled: multiple || false
        }, {
          value: loadBalancerTypeItem.Dedicated,
          label: 'Выделенный'
        }]
      }),
      accessibilityZoneQuantity: accessibilityZoneQuantity,
      dedicatedObj: dedicatedObj
    }
  };
};
var getArrayControl = function getArrayControl(multiple) {
  return {
    type: CONTROL.Array,
    accessorKey: 'configs',
    addText: 'Добавить балансировщик',
    min: 1,
    max: 3,
    defaultValue: [],
    ui: ['config'],
    controls: {
      config: getArrConfigControl(multiple)
    },
    invertTrashOffset: true
  };
};
var accessorKey = {
  elbType: 'configs[0].elb.type',
  configs: 'configs'
};
export var ELASTIC_LOAD_BALANCE_FORM_CONFIG = {
  ui: ['elbTypeObj', 'arrObj', 'arrMoreObj', 'eipIsNeeded'],
  controls: {
    elbTypeObj: {
      type: CONTROL.Object,
      ui: ['loadBalancerType'],
      visible: true,
      controls: {
        loadBalancerType: _objectSpread(_objectSpread({}, elbTypeControls.loadBalancerType), {}, {
          accessorKey: accessorKey.elbType
        })
      },
      watchedControls: {
        elbType: accessorKey.elbType
      },
      relateFn: function relateFn(_ref4) {
        var elbType = _ref4.elbType;
        if (elbType === loadBalancerTypeItem.Dedicated) {
          return {
            visible: false
          };
        }
      }
    },
    arrObj: {
      type: CONTROL.Object,
      ui: ['arr'],
      controls: {
        arr: getArrayControl(false)
      },
      visible: false,
      watchedControls: {
        elbType: accessorKey.elbType,
        configs: accessorKey.configs
      },
      relateFn: function relateFn(_ref5) {
        var elbType = _ref5.elbType,
          configs = _ref5.configs;
        if (elbType === loadBalancerTypeItem.Dedicated && configs.length === 1) {
          return {
            visible: true
          };
        }
      }
    },
    arrMoreObj: {
      type: CONTROL.Object,
      ui: ['arr'],
      controls: {
        arr: getArrayControl(true)
      },
      visible: false,
      watchedControls: {
        elbType: accessorKey.elbType,
        configs: accessorKey.configs
      },
      relateFn: function relateFn(_ref6) {
        var elbType = _ref6.elbType,
          configs = _ref6.configs;
        if (elbType === loadBalancerTypeItem.Dedicated && configs.length > 1) {
          return {
            visible: true
          };
        }
      }
    },
    eipIsNeeded: getEip({
      switchKey: 'eipIsNeeded',
      velocityKey: 'eip.velocity',
      specificationKey: 'eip.specification',
      trafficKey: 'eip.traffic'
    })
  }
};